import { render, staticRenderFns } from "./permissionOperation.vue?vue&type=template&id=afcd425e&scoped=true"
import script from "./permissionOperation.vue?vue&type=script&lang=js"
export * from "./permissionOperation.vue?vue&type=script&lang=js"
import style0 from "./permissionOperation.vue?vue&type=style&index=0&id=afcd425e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcd425e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('afcd425e')) {
      api.createRecord('afcd425e', component.options)
    } else {
      api.reload('afcd425e', component.options)
    }
    module.hot.accept("./permissionOperation.vue?vue&type=template&id=afcd425e&scoped=true", function () {
      api.rerender('afcd425e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/positionManage/permissionOperation.vue"
export default component.exports